module.exports = __webpack_public_path__ + "img/wl_icon.cd68511c.png";